import React from 'react'
import {compose, lifecycle} from 'recompose'
import _ from 'lodash'
import getUrl from "../../getUrl";
import CategoryHeader from '../../finwhale/common/category/header'
import CategoryText from "../../finwhale/common/category/text";
import CategoryTable from "../../finwhale/common/category/table";
import styled from 'styled-components'
import CategoryNewList from '../../finwhale/common/category/new'
import getImgUrl from "../../getImgUrl";
import TranslateText from 'src/text/modal';

const TypeButton = styled.div`
  width: 220px;
  height: 267px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 30;  
  box-shadow: 0 47px 50px 0 rgba(43,0,20,.09);
  
  &:hover {
    background: rgb(235, 235, 235);
  }
  
  ${props => props.active
  ? 'background: rgb(235, 235, 235); color: black; text-decoration: none'
  : 'background: #fff; color: #0054ff; cursor: pointer; & span { border-bottom: 1px dashed; }'
  }
`

const Provoda = ({install_axis, loading}) => (
  <div>
    <div style={{width: '80%', margin: '0 auto', fontSize: '18px'}}>

      <CategoryHeader
        name='catalogue_wires__title'
        img={getImgUrl(`/media/static/cats/provoda2.png`)}
        box={'catalogue_wires__box'}
        settingsText='catalogue_wires__settings'
        protectedText='catalogue_wires__protected'
        checkedText='catalogue_wires__checked'
      />

      <CategoryTable
        loading={loading}
        install_axis={install_axis}
        autosize
      />

      <CategoryNewList type={23}/>

      <CategoryText
        characteristics={'catalogue_wires__characteristics'}
        advantages={'catalogue_wires__additional_benefits'}
      />


      <TranslateText
        id={'catalogue_wires__table'}
        useHtml
        controls={['img']}
      />

    </div>
  </div>
)

const enhance = compose(
  lifecycle({
    state: {loading: true},
    componentDidMount() {
      fetch(getUrl(`/cat/v1/item?type_id=23`)).then(data => {
        return data.json()
      }).then(listItems => {
        const install_axis = _.get(listItems, 'data.data')
        this.setState({install_axis, loading: false})
      }).catch(err => {
        console.log(err)
      })
    },
  }),
)

export default enhance(Provoda)



// WEBPACK FOOTER //
// ./src/pages/production/high-tension-leads.js